import React, { FC, ReactNode } from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from 'reactstrap';
import { useTranslation } from '../translations';
import { classNames } from '../utils';
import { UserAvatar } from '../utils/UserAvatar';
import { MaterialIcon } from './MaterialIcon';

import './ElementHeader.scss';

interface AvatarProps {
  url?: string;
  iconName?: string;
}

interface HeaderAction {
  id: string;
  danger?: boolean;
  header?: boolean;
  disabled?: boolean;
  divider?: boolean;
  onClick?: () => void;
  href?: string;
  text?: string;
}

interface ElementHeaderProps {
  readonly children?: ReactNode;
  readonly icon?: AvatarProps;
  readonly title: React.JSX.Element | string;
  readonly rightContent?: React.JSX.Element;
  readonly actions?: HeaderAction[];
  readonly hideDivider?: boolean;
}

export const ElementHeader: FC<ElementHeaderProps> = ({
  actions,
  children,
  icon,
  title,
  rightContent,
  hideDivider = false,
}) => {
  const { ts } = useTranslation();
  return (
    <>
      <div className="element-header clearfix">
        {rightContent && <div className="float-end">{rightContent}</div>}
        <div>
          {icon?.url && (
            <div className="float-start" style={{ marginRight: '15px' }}>
              <UserAvatar size="medium" url={icon.url} />
            </div>
          )}
          {icon?.iconName && (
            <MaterialIcon className="material-avatar" medium name={icon.iconName} />
          )}
        </div>
        <div className="element-header-target">
          <div className="element-header-title">
            <h4>{title}</h4>
            {children && <div className="element-header-child">{children}</div>}
          </div>
          {actions && actions.length > 0 && (
            <div className="element-header-actions">
              <UncontrolledButtonDropdown>
                <DropdownToggle caret color="secondary" outline>
                  {ts('common.actions')}
                </DropdownToggle>
                <DropdownMenu>
                  {actions.map((action) => (
                    <DropdownItem
                      className={classNames({ 'text-danger': action.danger })}
                      disabled={action.disabled}
                      divider={action.divider}
                      header={action.header}
                      href={action.href}
                      id={action.id}
                      key={action.id}
                      onClick={action.onClick}
                    >
                      {action.text}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </UncontrolledButtonDropdown>
            </div>
          )}
        </div>
        <div className="element-header-clear" />
      </div>
      {!hideDivider && <hr style={{ marginTop: '5px' }} />}
    </>
  );
};
